
import gql from 'graphql-tag';

const UPSERT_RED_FLAG = gql` 
  mutation upsertRedFlag($input: RedFlagInput) {
    upsertRedFlag(input: $input) {
      message
      code
    }
  }
`;

export default UPSERT_RED_FLAG;